var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21C18 21 14 20 14 13V4.99997C14 3.74997 14.756 2.98297 16 2.99997H20C21.25 2.99997 22 3.74997 22 4.97197V11C22 12.25 21.25 13 20 13C19 13 19 13 19 14V15C19 16 20 17 21 17C22 17 22 17.008 22 18.031V20C22 21 22 21 21 21Z",
    stroke: "#F0A202",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21C6 21 2 20 2 13V4.99997C2 3.74997 2.757 2.98297 4 2.99997H8C9.25 2.99997 10 3.74997 10 4.97197V11C10 12.25 9.25 13 8 13H7.25C7.25 15.25 7 17 10 17V20C10 21 10 21 9 21Z",
    stroke: "#F0A202",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.9124cb9f4c946d05d6a99e1db8bb3656.svg";
export { ForwardRef as ReactComponent };